import { createSelector } from 'reselect'

import { selectEmrVersionConfig } from 'selectors/selectEmrVersionConfig'

export const selectIsManagedScalingAllowed = createSelector(
  [selectEmrVersionConfig],
  (emrVersionConfig) => emrVersionConfig.get('managed_scaling') === 'yes'
)
